/**************************************************
 * Nombre:       Ingreso
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     5 Hr
 **************************************************/
import {Button, Grid, Typography} from "@mui/material";
import {Google} from "@mui/icons-material";
import {useCargador} from "../../Modulo_Cargador/Hooks/useCargador";
import {ingresarConGoogle} from "../../Servicios/Auth/Funciones/ingresarConGoogle";
import logoRedondo from "../../Recursos/logo_redondo.svg";
import logo from "../../Recursos/logo_blanco.svg";
import {usePoliticas} from "../Hooks/usePoliticas";
import {theme} from "../../Tema";
import Formulario_Registro from "../Formularios/Formulario_Registro";
import {useFormulario} from "../../Modulo_formularios/Hooks/useFormulario";
import {useEffect} from "react";


const Ingreso = ({setCodigo, llega}) => {
    const {props, obtenerEntidad} = useFormulario({valoresDefecto: {}})
    const {Cargador, iniciarCarga, Avisos, nuevoAviso, terminar} = useCargador({logoRedondo: logoRedondo})
    const {Politica, value} = usePoliticas({politica: 'Acepto política de la plataforma'})
    const {
        Politica: PoliticaDatos,
        value: valueDatos
    } = usePoliticas({politica: 'Acepto política de tratamiento de datos'})

    const ingresar = async () => {
        let entidad = await obtenerEntidad()
        if (entidad.codigo) {
            setCodigo(entidad.codigo)
        }
        await ingresarConGoogle()

    }

    const clickBoton = () => {

        if (valueDatos && value) {
            ingresar()
        } else {
            terminar({aviso: 'Acepta primero las politicas', variante: 'error'})
        }
    }


    useEffect(() => {
        if (llega) {
            props.setValue('codigo', llega)
        }
    }, [llega])
    return (
        <Grid
            container
            justifyContent={'flex-start'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}>

            <Cargador/>

            <Avisos/>

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                <Grid
                    container
                    direction="row"
                    justifyContent="flex-start"
                    alignItems="flex-end"
                    spacing={2}
                >

                    <Grid container size={12} sx={{justifyContent: 'flex-start', mt: 1}}>
                        <Typography sx={{fontSize: 22, fontWeight: 600, px: 1}}>Ingreso</Typography>
                    </Grid>

                    <Grid container size={12}
                          sx={{justifyContent: 'flex-start', marginTop: 0}}>
                        <Typography sx={{fontSize: 15, fontWeight: 300, px: 1}}>
                            Ingresa a BitNova World con tu cuenta de Google, ellos son nuestros proveedores de seguridad
                        </Typography>
                    </Grid>

                    <Grid container size={12} sx={{justifyContent: 'center', mt: 3}}>
                        <Button

                            fullWidth startIcon={<Google/>}
                            onClick={() => clickBoton()}
                            sx={{
                                pt: 1.5,
                                pb: 1.5,
                                mx: 1,
                                backgroundColor: (value && valueDatos) ? theme.palette.primary.main : 'rgba(202,202,202,0.37)'
                            }}
                        >Ingresar mediante
                            Google</Button>
                    </Grid>

                    <Grid container size={6} sx={{justifyContent: 'flex-start', px: 1}}>
                        <Typography sx={{fontSize: 14, lineHeight: 1.2}}>Si tienes un código de referido agregalo
                            aquí</Typography>
                    </Grid>

                    <Grid container size={6} sx={{justifyContent: 'flex-start', px: 1}}>
                        <Formulario_Registro props={props}/>
                    </Grid>


                    <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start', mt: 3, px: 1}}>
                        <PoliticaDatos datos={politicasDatos}/>
                    </Grid>


                    <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start', mt: -1, px: 1}}>
                        <Politica datos={politicasPlataforma}/>
                    </Grid>


                    <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-end', mt: 2}}>
                        <img src={logo} width={80} height={'auto'} style={{opacity: 0.5}}/>
                    </Grid>


                </Grid>
            </Grid>

        </Grid>
    )

}
export default Ingreso

const politicasDatos = {

    nombre: 'Politica datos',
    descripcion: 'En BitNova, valoramos la confianza de nuestros usuarios y garantizamos la protección de sus datos personales conforme a las disposiciones legales aplicables en materia de protección de datos.\n' +
        '\n' +
        '1. Responsable del tratamiento de datos\n' +
        '\n' +
        'BitNova será responsable del tratamiento y la administración de la información personal recolectada a través de nuestra página web, formularios de registro, plataforma y demás canales autorizados.\n' +
        '\n' +
        '2. Datos recolectados\n' +
        '\n' +
        'Podremos solicitar y almacenar información como:\n' +
        '\n' +
        'Nombres y apellidos.\n' +
        '\n' +
        'Documento de identidad.\n' +
        '\n' +
        'Dirección de correo electrónico.\n' +
        '\n' +
        'Teléfono de contacto.\n' +
        '\n' +
        'Datos financieros relacionados con el uso de nuestros servicios.\n' +
        '\n' +
        '3. Finalidad del tratamiento\n' +
        '\n' +
        'La información recolectada será utilizada para:\n' +
        '\n' +
        'Gestionar el registro y acceso a la plataforma.\n' +
        '\n' +
        'Procesar transacciones y contratos de inversión.\n' +
        '\n' +
        'Enviar información sobre el estado de la cuenta, notificaciones y actualizaciones.\n' +
        '\n' +
        'Compartir novedades, promociones o cambios en nuestros servicios.\n' +
        '\n' +
        'Cumplir con obligaciones legales y regulatorias.\n' +
        '\n' +
        '4. Derechos de los titulares\n' +
        '\n' +
        'Los usuarios podrán ejercer en cualquier momento los derechos que les corresponden sobre sus datos personales, entre ellos:\n' +
        '\n' +
        'Acceder, actualizar, rectificar y suprimir sus datos.\n' +
        '\n' +
        'Solicitar prueba del consentimiento otorgado.\n' +
        '\n' +
        'Ser informados sobre el uso dado a sus datos.\n' +
        '\n' +
        'Revocar la autorización de uso de los datos.\n' +
        '\n' +
        '5. Confidencialidad y seguridad\n' +
        '\n' +
        'BitNova implementa medidas técnicas, administrativas y de seguridad razonables para proteger los datos personales contra acceso no autorizado, pérdida, alteración o divulgación indebida.\n' +
        '\n' +
        '6. Transferencia y transmisión de datos\n' +
        '\n' +
        'Los datos personales podrán ser transmitidos o transferidos, dentro o fuera del país, únicamente a aliados estratégicos o proveedores que apoyen la operación de nuestros servicios, bajo acuerdos que garanticen la seguridad de la información.\n' +
        '\n' +
        '7. Conservación de la información\n' +
        '\n' +
        'Los datos serán conservados únicamente por el tiempo necesario para cumplir con las finalidades descritas o lo exigido por la normativa aplicable.\n' +
        '\n' +
        '8. Modificaciones a la política\n' +
        '\n' +
        'BitNova se reserva el derecho de actualizar esta política en cualquier momento. Los cambios serán publicados en nuestro sitio web.\n' +
        '\n' +
        '9. Contacto\n' +
        '\n' +
        'Para ejercer sus derechos o presentar consultas y reclamos relacionados con sus datos, puede comunicarse a:\n' +
        '📧 antencion@bitnovaworld.com\n'
}


const politicasPlataforma = {

    nombre: 'Politica Plataforma',
    descripcion: '1.⁠ ⁠Rentabilidad Diaria\n' +
        'La plataforma genera un retorno del 1% diario sobre el capital invertido, el cual se acredita de forma automática en su cuenta.\n' +
        '\t\n' +
        '2.⁠ ⁠Bonificaciones por Referidos\n' +
        'Recibe un bono directo por referidos según el siguiente esquema:\n' +
        '\n' +
        '\n' +
        '\t•\t10% por el primer nivel\n' +
        '\t•\t8% por el segundo nivel\n' +
        '\t•\t6% por el tercer nivel\n' +
        '\t•\t4% por el cuarto nivel\n' +
        '\t•\t2% por el quinto nivel\n' +
        '\t•\t1% por el sexto nivel\n' +
        '\n' +
        '\t3.\tPlan de Carrera\n' +
        'Accede al plan de carrera con premios materiales (como dispositivos, viajes u otros) al cumplir metas de volumen acumulado por estructura según los rangos establecidos.\n' +
        '\n' +
        '\t4.\tPolítica de Retiros\n' +
        '\t•\tRetiro PREMIUM: Comisión del 14%, con procesamiento entre 16 a 32 horas.\n' +
        '\n' +
        '\t•\tRetiro STANDARD: Comisión del 10%, con procesamiento entre 24 a 72 horas.\n' +
        '\n' +
        '\t•\tTodos los retiros se realizan en USDT - red BEP20.\n' +
        '\n' +
        '\t5.\tCancelación de Contrato\n' +
        'Si el usuario decide cancelar su inversión antes del tiempo pactado, se aplicará una penalización del 40%, devolviendo únicamente el 60% del capital invertido.\nCláusula 1: Responsabilidad del Usuario\n' +
        '\n' +
        'La inversión realizada a través de esta plataforma es bajo la entera responsabilidad del usuario. La plataforma BitNova World no se hace responsable por pérdidas, decisiones de inversión ni resultados derivados del uso de sus servicios.\n' +
        '\n' +
        '\n' +
        '\n' +
        'Cláusula 2: Canal de Comunicación Oficial\n' +
        '\n' +
        'En caso de errores, fallos o inconvenientes técnicos dentro de la plataforma, el usuario deberá comunicarse exclusivamente al siguiente correo oficial: atencion@bitnovaworld.com. No se considerarán válidas comunicaciones por otros medios no autorizados.\n' +
        '\n' +
        'Cláusula 3: Interrupción del Servicio\n' +
        '\n' +
        'En caso de que la plataforma deje de funcionar total o parcialmente por cualquier motivo, BitNova World no asumirá responsabilidad alguna por dicha interrupción. Asimismo, no se realizará reembol'
}